import React from "react";
import { Link } from "react-router-dom";
const { createSlug } = require("../libraries/Interiors");
const { tmdbAPIPosterLink } = require("../config");

const MovieCard = ({
    movie,
    toggleFavorite,
    favorites,
    watchedToggle,
    watched,
    isBlurred
}) => {
    const detailURL = `/details/${movie.id}-${createSlug(movie.title)}`;
    const isWatched = watched && watched.some(watch => watch.id === movie.id);
    return (
       
        
        <li
            className="movie"
            style={{
                filter: `${isWatched && isBlurred ? "blur(2px)" : "blur(0px)"}`
            }}
        >
            <Link to={detailURL} style={{ color: "rgb(0,0,0)" }}>
                <div
                    className="cover"
                    style={{
                        backgroundImage:
                            'url("' +
                            tmdbAPIPosterLink.replace(
                                "POSTER_LINK",
                                movie.poster_path
                            ) +
                            '")'
                    }}
                    title={`${movie.title} (${
                        movie.release_date.split("-")[0]
                    })`}
                />
            </Link>
       
            <div className="movie-info">
                <Link to={detailURL} style={{ color: "rgb(0,0,0)" }}>
                    <h1
                        className="title"
                        title={`${movie.title} (${
                            movie.release_date.split("-")[0]
                        })`}
                    >
                        {`${movie.title} (${movie.release_date.split("-")[0]})`}
                    </h1>
                </Link>
                <span>
                    <span
                        className={`icon-eye${isWatched ? "" : "-blocked"}`}
                        style={{ color: isWatched ? "rgb(193, 93, 87)" : "" }}
                        onClick={() => watchedToggle(movie)}
                        title={`Add ${movie.title} to your watched list.`}
                    />

                    <span className="favorite">
                        <span
                            className={`btnfavorite icon-heart-${
                                favorites.some(movies => movies.id === movie.id)
                                    ? "fill"
                                    : "stroke"
                            }`}
                            onClick={() => toggleFavorite(movie)}
                            title={`Add ${movie.title} to your favorites.`}
                        />
                    </span>
                </span>
            </div>
        </li>
    );
};

export default MovieCard;



// WEBPACK FOOTER //
// ./src/components/MovieCard.js